import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  wrapperCard: {
    backgroundColor: "white",
    border: "1px solid #f2f2f2",
    borderRadius: theme.spacing(0.875),
    overflow: "hidden",
    height: "fit-content",
    position: "relative",
  },
  todayBody: {
    backgroundColor: "#000",
  },
  body: {
    // fontFamily: "SFProText-Bold, sans-serif",
    backgroundColor: "#f2f2f2",
    justifyContent: "center",
  },
  bodyContent: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#fff",
    margin: theme.spacing(0.5),
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1),
    width: "100%",
    minHeight: theme.spacing(25),
    maxHeight: theme.spacing(25),
    overflowY: "scroll",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      width: 0,
      height: 0,
    },
  },
  bodyContentRow: {
    display: "flex",
    flexDirection: "column",
    rowGap: theme.spacing(1.5),
  },
  label: {
    color: "black",
    fontWeight: "bold",
    fontSize: "15px",
    display: "flex",
    flex: 1,
  },
  title: {
    marginTop: theme.spacing(1.25),
    color: "#a2a2a2",
    textTransform: "uppercase",
    fontWeight: "bold",
    fontSize: "12px",
  },
  textNotes: {
    fontSize: "13px",
    color: "#0c0c0c",
    fontFamily: "SFProText-Regular, sans-serif",
    textAlign: "left",
  },
  blockType: {
    fontSize: "17px",
    display: "block",
    marginBottom: theme.spacing(0.625),
  },
  labelBase: {
    color: "black",
    fontWeight: "bold",
    fontSize: "15px",
  },
  labelDistance: {
    color: "black",
    fontWeight: "bold",
    fontSize: "15px",
    lineHeight: 0,
  },
  labelWithMargin: {
    marginRight: theme.spacing(1),
  },
  iconBase: {
    minWidth: "20px",
    minHeight: "20px",
    borderRadius: "100%",
  },
  iconNoRes: {
    minWidth: "20px",
    minHeight: "20px",
    borderRadius: "100%",
    backgroundColor: "#ececec",
  },
  iconDone: {
    color: "#007935",
  },
  iconStop: {
    color: "#e7440c",
  },
  iconBlackRes: {
    minWidth: "20px",
    minHeight: "20px",
    borderRadius: "100%",
    color: "black",
  },
  milles: {
    lineHeight: 0,
    fontSize: "10px",
    color: "#a2a2a2",
    textTransform: "uppercase",
    marginLeft: theme.spacing(0.375),
  },
  footerDatePicker: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(2.5, 1.25),
  },
  clearBtn: {
    textDecoration: "underline",
    "&:hover": {
      cursor: "pointer",
    },
  },
  copyBtn: {
    backgroundColor: "#6fa088",
    color: "black",
  },
  iconContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
    flex: 1,
    display: "flex",
  },
}));

export default useStyles;
